import React from "react";
import { Button } from "antd";
import ApiImageList from "../containers/ApiImageList";
import { RouterLink } from "../routing";
import routes from "../routing/routes";

export default () => (
  <>
    <ApiImageList apiPath="/documentations" listDataKey="documentations" />

    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "3rem 0"
      }}
    >
      <RouterLink label="Doku erstellen" route={routes.documentationCreate}>
        <Button type="primary">Neue Doku erstellen</Button>
      </RouterLink>
    </div>
  </>
);
